<template lang="pug">
van-pull-refresh.dataList(ref="vanPullRefreshRef" v-model="refreshing" @refresh="onRefresh")
  van-list(v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad")
    slot
</template>
<script>
export default {
  name: "ListScroller",
  props: { finished: { type: Boolean } },
  data() {
    return {
      loading: false, // 加载更多
      refreshing: false, // 重新加载
      listHeight: "" // 容器高度  可传 66 -66 '66' '-66' 全屏高度则不传
    };
  },
  methods: {
    onRefresh() {
      this.$emit("on-pulldown-loading", () => {
        this.refreshing = false; // 下拉刷新成功后关闭顶部刷新状态
      });
    },
    onLoad() {
      this.$emit("on-pullup-loading", () => {
        this.loading = false; // 上拉加载成功后关闭底部加载状态
      });
    }
  }
};
</script>
<style lang="less" scoped>
.dataList {
  height: 100%;
  overflow: auto;
  .van-list {
    height: 100%;
  }
}
</style>
